/**
 * Een mislukte aanroep in gewone taal. Kwam uit de map van motor 6.1
 * (sessie 105); verhuisd naar gedeeld in sessie 8D, werking gelijk.
 */

/** HTTP-status van een mislukte aanroep, of null. */
export function foutStatus(fout: unknown): number | null {
  const s = (fout as { response?: { status?: unknown } } | null)?.response
    ?.status;
  return typeof s === "number" ? s : null;
}

/**
 * De redenen van de server als losse regels. FastAPI geeft een tekst
 * (`detail: "..."`), een lijst validatiefouten (`detail: [{msg, loc}]`) of
 * een lijst teksten.
 */
export function foutRegels(fout: unknown): string[] {
  const detail = (fout as { response?: { data?: { detail?: unknown } } } | null)
    ?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return [detail.trim()];
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        if (typeof d === "string") return d;
        if (d && typeof d === "object") {
          const o = d as { msg?: unknown; loc?: unknown; fout?: unknown };
          const tekst =
            typeof o.msg === "string"
              ? o.msg
              : typeof o.fout === "string"
                ? o.fout
                : null;
          const plek = Array.isArray(o.loc)
            ? o.loc.filter((x) => x !== "body").join(".")
            : "";
          if (tekst) return plek ? `${plek}: ${tekst}` : tekst;
          return JSON.stringify(d);
        }
        return String(d);
      })
      .filter(Boolean);
  }
  return [];
}

/** "Opslaan mislukt. <reden van de server>" of alleen de vaste zin. */
export function foutTekst(fout: unknown, standaard: string): string {
  if (foutStatus(fout) === 403)
    return `${standaard} Alleen een beheerder mag dit.`;
  const regels = foutRegels(fout);
  return regels.length ? `${standaard} ${regels.join(" ")}` : standaard;
}
